/**
 * Флаг доступа к ОПЗ 2.0 на сущности project в Firebase:
 * /project/<projectId>/isOpz2Enabled = true
 *
 * Приходит на фронт как есть в объекте проекта (mapProject отдаёт всю сущность),
 * поэтому отдельного запроса не нужно.
 */
export const OPZ2_PROJECT_FLAG = 'isOpz2Enabled'

export interface Opz2ProjectLike {
    id?: string
    isOpz2Enabled?: boolean
    connectors?: Array<{ deleted?: boolean; connectorType?: string }>
}

export function hasOpz2Access(project?: Opz2ProjectLike | null): boolean {
    return Boolean(project?.id) && project?.[OPZ2_PROJECT_FLAG] === true
}
